import { createRoot } from 'react-dom/client';

import Root from 'src/components/Root';
import { applyTheme, readTheme } from 'src/utils/theme';

applyTheme(readTheme());

const root = createRoot(document.getElementById('root'));

root.render(<Root />);
